import {$, cnpj, datetime, InputType, phone, Schema} from 'simpli-web-sdk'
import RenderLabelValue from '@/components/render/RenderLabelValue.vue'
import {CargaConcreto} from '@/model/resource/CargaConcreto'

export default (model: CargaConcreto): Schema => ({
    idCargaConcretoPk: {
        content: [
            {
                component: RenderLabelValue,
                props: {
                    label: model.translateColumn('idCargaConcretoPk'),
                    value: model.idCargaConcretoPk || $.t('app.notInformed'),
                },
            },
        ],
        input: InputType.TEXT,
    },
    idCargaFk: {
        content: [
            {
                component: RenderLabelValue,
                props: {
                    label: model.translateColumn('idCargaFk'),
                    value: model.idCargaFk || $.t('app.notInformed'),
                },
            },
        ],
        input: InputType.TEXT,
    },
    contrato: {
        content: [
            {
                component: RenderLabelValue,
                props: {
                    label: model.translateColumn('contrato'),
                    value: model.contrato || $.t('app.notInformed'),
                },
            },
        ],
    },
    descricaoProduto: {
        content: [
            {
                component: RenderLabelValue,
                props: {
                    label: model.translateColumn('descricaoProduto'),
                    value: model.descricaoProduto || $.t('app.notInformed'),
                },
            },
        ],
        input: InputType.TEXT,
    },
    usina: {
        content: [
            {
                component: RenderLabelValue,
                props: {
                    label: model.translateColumn('usina'),
                    value: model.usina || $.t('app.notInformed'),
                },
            },
        ],
    },
    horarioChegadaObra: {
        content: [
            {
                component: RenderLabelValue,
                props: {
                    label: model.translateColumn('horarioChegadaObra'),
                    value: datetime(model.horarioChegadaObra) || $.t('app.notInformed'),
                },
            },
        ],
        input: InputType.TEXT,
    },
    horarioInicioDescarga: {
        content: [
            {
                component: RenderLabelValue,
                props: {
                    label: model.translateColumn('horarioInicioDescarga'),
                    value: datetime(model.horarioInicioDescarga) || $.t('app.notInformed'),
                },
            },
        ],
        input: InputType.TEXT,
    },
    horarioTerminoDescarga: {
        content: [
            {
                component: RenderLabelValue,
                props: {
                    label: model.translateColumn('horarioTerminoDescarga'),
                    value: datetime(model.horarioTerminoDescarga) || $.t('app.notInformed'),
                },
            },
        ],
        input: InputType.TEXT,
    },
    adicaoAgua: {
        content: [
            {
                component: RenderLabelValue,
                props: {
                    label: model.translateColumn('adicaoAgua'),
                    value: model.adicaoAgua,
                },
            },
        ],
        input: InputType.TEXT,
    },
    retornoConcreto: {
        content: [
            {
                component: RenderLabelValue,
                props: {
                    label: model.translateColumn('retornoConcreto'),
                    value: model.retornoConcreto,
                },
            },
        ],
        input: InputType.TEXT,
    },
    horarioSaidaObra: {
        content: [
            {
                component: RenderLabelValue,
                props: {
                    label: model.translateColumn('horarioSaidaObra'),
                    value: datetime(model.horarioSaidaObra) || $.t('app.notInformed'),
                },
            },
        ],
        input: InputType.TEXT,
    },
    horarioChegadaCentral: {
        content: [
            {
                component: RenderLabelValue,
                props: {
                    label: model.translateColumn('horarioChegadaCentral'),
                    value: datetime(model.horarioChegadaCentral) || $.t('app.notInformed'),
                },
            },
        ],
        input: InputType.TEXT,
    },
    hodometroInicial: {
        content: [
            {
                component: RenderLabelValue,
                props: {
                    label: model.translateColumn('hodometroInicial'),
                    value: model.hodometroInicial || model.hodometroInicial === 0 ?
                      model.hodometroInicial :
                      $.t('app.notInformed'),
                },
            },
        ],
        input: InputType.TEXT,
    },
    hodometroFinal: {
        content: [
            {
                component: RenderLabelValue,
                props: {
                    label: model.translateColumn('hodometroFinal'),
                    value: model.hodometroFinal || model.hodometroFinal === 0 ?
                    model.hodometroFinal :
                    $.t('app.notInformed'),
                },
            },
        ],
        input: InputType.TEXT,
    },
})
